var _g, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScoreMedium(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-281 373 48 48",
    enableBackground: "new -281 373 48 48",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    display: "none",
    fillOpacity: 0.3,
    d: "M-277,417h40v-40L-277,417z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-240,384.2V414h-29.8L-240,384.2 M-237,377l-40,40h40V377L-237,377z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-253,393l-24,24h24V393z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-281,373h48v48h-48V373z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreMedium);
export default __webpack_public_path__ + "static/media/score-medium.b296f7ea.svg";
export { ForwardRef as ReactComponent };